export default __webpack_public_path__ + "986316aad5e5c4c5a09d48fc92209d0a.png";